/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoogleSearchConsoleBrandRuleSetData
 */
export interface GoogleSearchConsoleBrandRuleSetData {
    /**
     * 
     * @type {string}
     * @memberof GoogleSearchConsoleBrandRuleSetData
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof GoogleSearchConsoleBrandRuleSetData
     */
    version?: number;
    /**
     * 
     * @type {Date}
     * @memberof GoogleSearchConsoleBrandRuleSetData
     */
    effectiveFrom?: Date;
    /**
     * 
     * @type {Array<string>}
     * @memberof GoogleSearchConsoleBrandRuleSetData
     */
    terms?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GoogleSearchConsoleBrandRuleSetData
     */
    reason?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleSearchConsoleBrandRuleSetData
     */
    createdAt?: string;
}

/**
 * Check if a given object implements the GoogleSearchConsoleBrandRuleSetData interface.
 */
export function instanceOfGoogleSearchConsoleBrandRuleSetData(value: object): value is GoogleSearchConsoleBrandRuleSetData {
    return true;
}

export function GoogleSearchConsoleBrandRuleSetDataFromJSON(json: any): GoogleSearchConsoleBrandRuleSetData {
    return GoogleSearchConsoleBrandRuleSetDataFromJSONTyped(json, false);
}

export function GoogleSearchConsoleBrandRuleSetDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleSearchConsoleBrandRuleSetData {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'version': json['version'] == null ? undefined : json['version'],
        'effectiveFrom': json['effectiveFrom'] == null ? undefined : (new Date(json['effectiveFrom'])),
        'terms': json['terms'] == null ? undefined : json['terms'],
        'reason': json['reason'] == null ? undefined : json['reason'],
        'createdAt': json['createdAt'] == null ? undefined : json['createdAt'],
    };
}

export function GoogleSearchConsoleBrandRuleSetDataToJSON(json: any): GoogleSearchConsoleBrandRuleSetData {
    return GoogleSearchConsoleBrandRuleSetDataToJSONTyped(json, false);
}

export function GoogleSearchConsoleBrandRuleSetDataToJSONTyped(value?: GoogleSearchConsoleBrandRuleSetData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'version': value['version'],
        'effectiveFrom': value['effectiveFrom'] == null ? value['effectiveFrom'] : value['effectiveFrom'].toISOString().substring(0,10),
        'terms': value['terms'],
        'reason': value['reason'],
        'createdAt': value['createdAt'],
    };
}

